<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
				<th :class="StyleTh">Teléfono</th>
                <th :class="StyleTh">Clave Sucursal</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{ lista.Nombre }}</h6></td>
					<td><p :class="StyleTd">{{ lista.Telefono }}</p></td>
                    <td><p :class="StyleTd">{{ lista.ClaveSucursal }}</p></td>
                    
                    <td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdSucursal" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <button type="button" @click="AbrirModalUsuario(lista)" class="btn btn-link text-secondary px-3 mb-0 mr-1">
                                    <i class="fas fa-user text-secondary"></i> Usuario
                                </button>

                                <button type="button" @click="AbrirModalTimbrado(lista)" class="btn btn-link text-secondary px-3 mb-0 mr-1">
                                    <i class="fas fa-file-code text-warning"></i> Archivos SAT
                                </button>

                                <button type="button" @click="IraTimbres(lista)" class="btn btn-link text-secondary px-3 mb-0 mr-1">
                                    <i class="fas fa-bell text-success"></i> Timbres
                                </button>
                                
                                <button type="button" @click="IrAPaquetes(lista)" class="btn btn-link text-secondary px-3 mb-0">
                                    <i class="fas fa-box-check text-secondary me-1"></i> Ver Paquetes
                                </button>
                            </template>
						</CBtnAccion>     
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="18"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

		<CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
			<template slot="Form">
				<Form2 :poBtnSave="oBtnSave2"></Form2>
			</template>
		</CModal>

		<CModal :pConfigModal="ConfigModal3" :poBtnSave="oBtnSave3">
			<template slot="Form">
				<Form3 :poBtnSave="oBtnSave3"></Form3>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/root/sucursal/Form.vue';
import Form2 from '@/views/modulos/root/sucursal/FormUser.vue';
import Form3 from '@/views/modulos/root/sucursal/FormArchivos.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionSucursal';
const EmitEjecuta2 = 'seccionSucursalUsuario';
const EmitEjecuta3 = 'seccionArchivosSAT';

export default {
    name: 'ListaSucursal',
    props:['pObjEnviado'],
    components: {
        Form,
        Form2,
        Form3,
    },
    data() {
        return {
            ConfigList:{
                Title: 'Listado de Sucursales',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                ShowTitleFirst: false,
                EmitSeccion: EmitEjecuta,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            ConfigModal:{
                ModalTitle: "Formulario Sucursal",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'lg',
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            ConfigModal2:{
                ModalTitle: "Formulario Usuario",
                ModalNameId: 'ModalForm2',
                EmitSeccion: EmitEjecuta2,
                ModalSize: 'lg',
            },
            oBtnSave2: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            ConfigModal3:{
                ModalTitle: "Formulario Archivos Sat",
                ModalNameId: 'ModalForm3',
                EmitSeccion: EmitEjecuta3,
                ModalSize: 'lg',
            },
            oBtnSave3: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjEmpresa: {},
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("sucursales",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdEmpresa: this.ObjEmpresa.IdEmpresa,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                //this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('sucursales/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        IrAPaquetes(item){
            this.$router.push({name:'paquetesSistemaEmpresa',params:{pOrigen:'Sucursal',ObjEnviado:item}});
        },
        Regresar(){
            this.$router.push({name:'cuentaEmpresa',params:{}});
        },
        AbrirModalUsuario(item)
		{
            this.bus.$emit('NewModal_'+EmitEjecuta2,item);
		},
        AbrirModalTimbrado(item)
		{
            this.bus.$emit('NewModal_'+EmitEjecuta3,item);
		},
        IraTimbres(item){
            this.$router.push({name:'timbresHistorial',params:{pObjEnviado: item}});
        },
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objEmpresa',JSON.stringify(this.pObjEnviado));
        }

        this.ObjEmpresa = JSON.parse(sessionStorage.getItem('objEmpresa'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjEmpresa.NombreComercial;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
